export default __webpack_public_path__ + "img/69fefb0dc030b78f75336b0469283b51.png";